var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M14.6009 3H17.0544L11.6943 8.93026L18 17H13.0627L9.19566 12.1057L4.77087 17H2.31595L8.04904 10.6569L2 3H7.06262L10.5581 7.47354L14.6009 3ZM13.7399 15.5785H15.0993L6.32392 4.34687H4.86506L13.7399 15.5785Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a651bd78c72c74d5789c6b1ca2bcc7cf.svg";
export { ForwardRef as ReactComponent };